import group from "../operations/undo_group";
import {getSheet} from "../sheets";

export function freezeColumns(column, page){
	let oldValue;

	group.set(()=>{
		if(page && page != this.getActiveSheet()){
			const sheet = getSheet(this, page);
			if(sheet){
				if(!sheet.content.table)
					sheet.content.table = {};
				oldValue = sheet.content.table.frozenColumns;
				sheet.content.table.frozenColumns = column;
				if(sheet.content.spans)
					checkSpans(this, "column", column, sheet.content.spans);
			}
		}
		else{
			if(!page)
				page = this.getActiveSheet();
			const grid = this.$$("cells");

			if( webix.isUndefined(column) ){
				const sel = grid.getSelectArea();
				column = sel ? sel.end.column : 0;
			}

			const base = grid.config.columns[0].id == "rowId" ? 1 : 0;
			let index = base;
			let removeFreeze = false;
			if (column && column != this._frozenColumns){
				for (let i = column; i > 0; i--) {
					index = grid.getColumnIndex(i)+1;
					if(index)
						break;
				}
				if (!index) index = base;
			}
			else removeFreeze = true;

			checkSpans(this, "column", column);
			grid.unselect();
			grid.define("leftSplit", index);
			grid.refreshColumns();
			oldValue = this._frozenColumns;
			this._frozenColumns = (removeFreeze || !column) ? 0 : column;
		}
		this.callEvent("onAction", [ "freeze-column", { value: (oldValue || 0), newValue: column, page}]);
	});
}

export function freezeRows(row, page){
	let oldValue;

	group.set(()=>{
		if(page && page != this.getActiveSheet()){
			const sheet = getSheet(this, page);
			if(sheet){
				if(!sheet.content.table)
					sheet.content.table = {};
				oldValue = sheet.content.table.frozenRows;
				sheet.content.table.frozenRows = row;
				if(sheet.content.spans)
					checkSpans(this, "row", row, sheet.content.spans);
			}
		}
		else{
			if(!page)
				page = this.getActiveSheet();
			const grid = this.$$("cells");

			if( webix.isUndefined(row) ){
				const sel = grid.getSelectArea();
				row = sel ? sel.end.row : 0;
			}

			let index = 0;
			let removeFreeze = false;
			if (row && row != this._frozenRows){
				for (let i = row; i > 0; i--) {
					index = grid.getIndexById(i)+1;
					if(index)
						break;
				}
			}
			else removeFreeze = true;

			checkSpans(this, "row", row);
			grid.unselect();
			grid.define("topSplit", index);
			grid.refreshColumns();
			oldValue = this._frozenRows;
			this._frozenRows = (removeFreeze || !row) ? 0 : row;
		}
		this.callEvent("onAction", [ "freeze-row", { value: (oldValue || 0), newValue: row, page}]);
	});
}

function checkSpans(view, type, num, spans){
	if(spans){
		for (let i = spans.length - 1; i >= 0; i--) {
			const span = spans[i];

			const index1 = type == "row" ? 0 : 1;
			const index2 = type == "row" ? 3 : 2;

			if(span[index1] <= num && span[index1] + span[index2] - 1 > num)
				span[index2] = num - span[index1] + 1;
			if(span[0] - span[3] == 0 && span[1] - span[2] == 0)
				spans.splice(i, 1);
		}
	}
	else{
		const grid = view.$$("cells");
		const spans = grid.getSpan();
		let changed;

		for(let row in spans){
			if(type == "row" && row > num)
				continue;

			for (let col in spans[row]){
				if(type == "column" && col > num)
					continue;

				const span = spans[row][col];
				const spanSize = type == "row" ? (row*1) + span[1] - 1 : (col*1) + span[0] - 1;

				if(spanSize > num){
					changed = true;
					changeSpan(
						view,
						[row, col],
						type == "row" ? span[0] : span[0] - (spanSize - num),
						type == "row" ? span[1] - (spanSize - num) : span[1]
					);
				}
			}
		}

		if(changed)
			view.refresh();
	}
}

function changeSpan(view, span, x, y){
	view.splitCell(span[0], span[1], null, true);
	view.combineCells(
		{
			cell:{
				row:span[0],
				column:span[1]
			},
			x,
			y,
		},
		null,
		true
	);
}